import { render, staticRenderFns } from "./redirectPage.vue?vue&type=template&id=d9385ef6&scoped=true"
import script from "./redirectPage.vue?vue&type=script&lang=js"
export * from "./redirectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9385ef6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9385ef6')) {
      api.createRecord('d9385ef6', component.options)
    } else {
      api.reload('d9385ef6', component.options)
    }
    module.hot.accept("./redirectPage.vue?vue&type=template&id=d9385ef6&scoped=true", function () {
      api.rerender('d9385ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/redirectPage.vue"
export default component.exports